// extracted by css-extract-rspack-plugin
var _1 = "QTnwwyzxb2gbDMzeUu-fDA--";
var _2 = "onf-BnWQtTij7Px-NODxfQ--";
export { _1 as "popoverContent", _2 as "signAndPayContent" }
